'use strict';

module.exports = /* @ngInject */ ["$rootScope", "rediTokenService", function ($rootScope, rediTokenService) {
  $rootScope.$on('event:auth-loginRequired', rediTokenService.refreshTokens);
}];



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/infrastructure/rediTokenRefreshSetup.js
// module id = 125
// module chunks = 0